import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Box from "@mui/material/Box";
import LeftArrowIcon from "../../images/right_arrow.svg";
import {
  getVeevaLinkedModulesListByid,
  getSelectedModulecardDetails,
  getModuleCardDetails,
} from "../../services/apis";
import "./LeftContentPanel.scss";
import GreenTickMark from "../../images/MLR StatusGreen.png";
import Rectangle from "../../images/Rectangle.svg";
import ModuleCardsWindow from "./ModuleCardsWindow";
import AssociatedModules from "./AssociatedModules";

const LeftContentPanel = (props) => {
  const [activeKey, setActiveKey] = useState("approved");
  const {
    sendAtomDetails2Canvas,
    handleModuleWindow,
    appData,
    searhModuleModal,
    customDrag,
    editor,
    selectedModule,
    setSelectedModule,
    activeTab,
  } = props;
  const [associatedCards, setAssociatedCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [moduleCardsDataLHS, setModuleCardsDataLHS] = useState([]);
  const [moduleClaimsData, setModuleClaimsData] = useState([]);
  const [openModulesModal, setOpenModulesModal] = useState(false);
  const [openModulesScreen, setOpenModulesScreen] = useState(false);
  const [noBussinessRules, setNoBussinessRules] = useState(false);

  useEffect(() => {
    getModules();
  }, [searhModuleModal]);

  const getModules = () => {
    setIsLoading(true);
    // console.log('eee----', appData);
    // appData.setDeckId({ ...appData?.deckId, _id: edetailId });
    getVeevaLinkedModulesListByid(
      appData?.deckId?._id,
      (response, err, errorCode) => {
        if (err) {
          setIsLoading(false);
        } else {
          setModuleCardsDataLHS(response.data.response.content_modules);
            const moduleList = [
  ...new Set(
    response?.data?.response?.content_modules?.map(m => m.module_name) ?? []
              )];
           if (editor)
          onLoadCalled(editor, moduleList);
           // if (!editor) return false;
          /* const allComps = editor?.getWrapper();
          if (!allComps || typeof allComps.find !== "function") {
            return false;
          }
          try {
            if (allComps) {
              const claimOnEditor = allComps?.find(`[module-claim]`);
              for (var i = 0; i < claimOnEditor.length; i++) {
                const moduleValue =
                  claimOnEditor[i].getAttributes()["module-claim"];
                if (!moduleList.includes(moduleValue)) {
                  claimOnEditor[i].remove();
                }
              }
            }
          } catch (err) {
            console.error("Error in wrapper.find:", err);
            return false;
          } */
          setIsLoading(false);
        }
      }
    );
  };

  const handleTabSelect = (key) => {
    setActiveKey(key); // Update the active tab when clicked
  };

  const handleGetChildModules = (moduleId) => {
    setIsLoading(true);
    getSelectedModulecardDetails(moduleId, (response, err, errorCode) => {
      if (err) {
        //   const errCoponent = errComponentToRender(errorCode);
        //   categoriesErr(errCoponent);
        //   setLoadingModules(false);
        //   setNoBussinessRules(false);
      } else {
        const businessRules = response?.data?.businessRules;
        let noData = response?.data?.businessRules.length > 0 ? false : true;
        setNoBussinessRules(noData);
        if (!businessRules) {
          setIsLoading(false);
          return;
        }
        const optionalModules = [];
        const mustExistWithModules = [];

        businessRules.forEach((rule) => {
          switch (rule.ruleCondition) {
            case "Optional":
              if (Array.isArray(rule.targetModules)) {
                rule.targetModules.forEach((module) => {
                  if (module.targetModuleMlrStatus === "Available for Use")
                    optionalModules.push({
                      ...module,
                      ruleCondition: rule.ruleCondition,
                    });
                });
              }
              break;
            case "MustExistWith":
              rule.targetModules.forEach((module) => {
                if (module.targetModuleMlrStatus === "Available for Use")
                  mustExistWithModules.push({
                    ...module,
                    ruleCondition: rule.ruleCondition,
                  });
              });
              break;

            default:
              break;
          }
        });
        setAssociatedCards((prevState) => ({
          ...prevState,
          [moduleId]: { optionalModules, mustExistWithModules },
        }));
        setIsLoading(false);
      }
    });
  };

  const handleExpandModuleClaims = (card, type) => {
    let moduleTypeID =
      type === "parentModule"
        ? card?.content_module_response.id
        : card?.targetModuleId;
    getModuleCardDetails(
      moduleTypeID,
      (response, err, errorCode) => {
        if (err) {
        } else {
          // setCardDetails({
          //   cardDetails: true,
          //   data: response.data,
          // });
          setModuleClaimsData(response.data);
        }
      },
      "linkedModulesType"
    );
  };

  editor?.on('load', () => {
    console.log('inside load editor api', editor);
     const moduleList = [
          ...new Set(moduleCardsDataLHS?.map((m) => m.module_name) ?? []),
    ];
    onLoadCalled(editor, moduleList)
  })
  const onLoadCalled = (editor, moduleList) => {
    
   
    console.log('called inside', moduleList);
        if (!editor) return false;
        const allComps = editor?.getWrapper();
        if (!allComps || typeof allComps.find !== "function") {
          return false;
        }
        try {
          if (allComps) {
            console.log("on try cards", moduleList)
            const claimOnEditor = allComps?.find(`[module-claim]`);
            for (var i = 0; i < claimOnEditor.length; i++) {
              const moduleValue = claimOnEditor[i].getAttributes()["module-claim"];
              if (!moduleList.includes(moduleValue)) {
                claimOnEditor[i].remove();
              }
            }
          }
        } catch (err) {
          console.error("Error in wrapper.find:", err);
          return false;
        }
  }
  return (
    <div className="left-content-panel">
      <Tabs
        defaultActiveKey={activeKey}
        onSelect={handleTabSelect}
        id="controlled-tab-example"
        className="left-panel-approved-tab"
      >
        <Tab eventKey="approved" id="left-panel-approved-tab">
          <div className="">
            {selectedModule === undefined && (
              <>
                <div class="approve-content">Approved Content</div>
                <ModuleCardsWindow
                  setSelectedModule={setSelectedModule}
                  setOpenModulesScreen={setOpenModulesScreen}
                  setOpenModulesModal={setOpenModulesModal}
                  handleModuleWindow={handleModuleWindow}
                  handleExpandModuleClaims={handleExpandModuleClaims}
                  handleGetChildModules={handleGetChildModules}
                  sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                  associatedCards={associatedCards}
                  moduleCardsDataLHS={moduleCardsDataLHS}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  activeTab={activeTab}
                  editor={editor}
                />
              </>
            )}
            <div className="left-content-module-card">
              {selectedModule !== undefined && (
                <AssociatedModules
                  selectedModule={selectedModule}
                  setSelectedModule={setSelectedModule}
                  moduleClaimsData={moduleClaimsData}
                  sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                  customDrag={customDrag}
                  editor={editor}
                />
              )}
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default LeftContentPanel;
